// extracted by mini-css-extract-plugin
module.exports = {"cell":"table-row_cell__2_G0y","hideOnMobile":"table-row_hideOnMobile__34FbI"};